import { isInternalLanguage, type TInternalLanguage } from '@/utils/constants/locale'

export const FORMS_DISPLAY_DATE_FORMAT = 'DD MMM, YYYY'
export const FORMS_INPUT_DATE_FORMAT = 'DD/MM/YYYY'

export const ISO_DATE_FORMAT = 'YYYY-MM-DD'
export const ISO_YEAR_AND_MONTH_FORMAT = 'YYYY-MM'
export const DATE_WITH_SPACES_FORMAT = 'DD MMM YYYY'
export const FULL_ISO_WITHOUT_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const DATE_NO_SEPARATOR_FORMAT = 'DDMMYYYY'
export const FLIGHT_DATE_CSS = 'ddd, MMM DD, YYYY'
export const FLIGHT_TIME_CSS = 'HH:mm'
export const CAMPAIGN_ARIA_DATE_FORMAT = 'D MMMM YYYY'

export const MONTH_YEAR_FORMAT = 'MMM. YYYY'
export const MONTH_YEAR_FORMAT_NO_DOT = 'MMM YYYY'
export const FULL_MONTH_YEAR_FORMAT = 'MMMM YYYY'

export const RIGA_TIMEZONE = 'Europe/Riga'

export const SB_DATE_FORMAT = 'YYYY-MM-DD HH:mm'

export const SHORT_DATE_FORMAT = 'DD.MM.YYYY'
export const SHORT_DATE_FORMAT_COMPACT = 'DD.MM.YY'

export const getShortDateForSpecificLocale = (locale: string): string => {
  const localeFormats: Record<TInternalLanguage, string> = {
    en: SHORT_DATE_FORMAT,
    lv: 'DD.MM.YYYY.',
    ru: SHORT_DATE_FORMAT,
    et: SHORT_DATE_FORMAT,
    de: SHORT_DATE_FORMAT,
    lt: 'YYYY MM DD',
    fi: 'D.M.YYYY',
    uk: SHORT_DATE_FORMAT
  }

  return isInternalLanguage(locale) ? localeFormats[locale] : SHORT_DATE_FORMAT
}
